export default __webpack_public_path__ + "static/logo-header-light-262c72c7e9e78e7dd206d54f5dba914e.svg";